import { useState, useEffect } from "react";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import toast from "react-hot-toast";
import "react-datepicker/dist/react-datepicker.css";
import * as OrganizationMasterService from "../../Services/OrganizationMaster/OrganizationMasterService";
import {
  FaSearch,
  FaToggleOn,
  FaToggleOff,
  FaSpinner,
  FaArrowDown,
  FaArrowUp,
} from "react-icons/fa";
import CommonPagination from "../../Common/CommonPagination";
import { Loader2 } from "lucide-react";
import { set } from "react-hook-form";
import OrgLocationMappingModal from "./OrgLocationMappingModal";
import CommonConfirmationModal from "../../Common/CommonConfirmationModal";
import './OrgLocMappingMaster.css'

const OrgLocMappingMasterComponent = () => {
  const [organizationMasterList, setOrganizationMasterList] = useState([]);

  const [searchLoading, setSearchLoading] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orgNames, setOrgNames] = useState([]);
  const [processingSortOrder, setProcessingSortOrder] = useState("desc");
  const [modalLoader, setModalLoader] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmationDescription, setConfirmationDescription] = useState("");
  const [selectedSearchColumn, setSelectedSearchColumn] = useState("all");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // const filteredOrganizationMasterList = organizationMasterList.filter(
  //   (rec) => {
  //     const searchLower = searchData.toLowerCase();

  //     return (
  //       rec.OrgLocationId?.toString().toLowerCase().includes(searchLower) ||
  //       rec.OrgLocationName?.toLowerCase().includes(searchLower) ||
  //       rec.OrganizationId?.toString().toLowerCase().includes(searchLower) ||
  //       rec.OrganizationName?.toLowerCase().includes(searchLower)
  //     );
  //   },
  // );

  const searchColumns = [
    { label: "All", value: "all" },
    { label: "Org ID", value: "OrganizationId" },
    { label: "Org Name", value: "OrganizationName" },
    { label: "Org Location ID", value: "OrgLocationId" },
    { label: "Org Location Name", value: "OrgLocationName" },
  ];

  // const filteredOrganizationMasterList = organizationMasterList
  //   .filter((rec) => {
  //     const searchLower = searchData.toLowerCase();

  //     return (
  //       rec.OrgLocationId?.toString().toLowerCase().includes(searchLower) ||
  //       rec.OrgLocationName?.toLowerCase().includes(searchLower) ||
  //       rec.OrganizationId?.toString().toLowerCase().includes(searchLower) ||
  //       rec.OrganizationName?.toLowerCase().includes(searchLower)
  //     );
  //   })
  //   .sort((a, b) => {
  //     const aVal = a.Is_Processing_Location ? 1 : 0;
  //     const bVal = b.Is_Processing_Location ? 1 : 0;

  //     return processingSortOrder === "asc" ? aVal - bVal : bVal - aVal;
  //   });

  const filteredOrganizationMasterList = organizationMasterList
    .filter((rec) => {
      if (!searchData) return true;

      const searchLower = searchData.toLowerCase();

      if (selectedSearchColumn === "all") {
        return (
          rec.OrganizationId?.toString().toLowerCase().includes(searchLower) ||
          rec.OrganizationName?.toLowerCase().includes(searchLower) ||
          rec.OrgLocationId?.toString().toLowerCase().includes(searchLower) ||
          rec.OrgLocationName?.toLowerCase().includes(searchLower)
        );
      }

      return rec[selectedSearchColumn]
        ?.toString()
        .toLowerCase()
        .includes(searchLower);
    })
    .sort((a, b) => {
      const aVal = a.Is_Processing_Location ? 1 : 0;
      const bVal = b.Is_Processing_Location ? 1 : 0;

      return processingSortOrder === "asc" ? aVal - bVal : bVal - aVal;
    });

  // Pagination logic
  const indexOfLastOrg = currentPage * itemsPerPage;
  const indexOfFirstOrg = indexOfLastOrg - itemsPerPage;
  const currentOrganizationMasterList = filteredOrganizationMasterList.slice(
    indexOfFirstOrg,
    indexOfLastOrg,
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchData]);

  useEffect(() => {
    fetchOrganizationMasterList();
  }, []);

  const fetchOrganizationMasterList = () => {
    setSearchLoading(true);

    OrganizationMasterService.OrganizationMaster()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setOrganizationMasterList(data.Data);
        } else {
          setOrganizationMasterList([]);
        }
      })
      .catch(() => toast.error("Something went wrong"))
      .finally(() => {
        setSearchLoading(false);
      });
  };

  const handleActivateDeActivateOrgLocationMapping = (rec) => {
    OrganizationMasterService.ActivateDeActivateOrgLocationMapping(
      rec.Id,
      !rec.IsActive,
    )
      .then(({ data }) => {
        if (data.IsSuccess) {
          const message = rec.IsActive
            ? "Organization Location Mapping Deactivated Successfully"
            : "Organization Location Mapping Activated Successfully";
          toast.success(message);
          fetchOrganizationMasterList();
        } else {
          toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  const handleActivateDeActivateProcessingLocation = (rec) => {
    OrganizationMasterService.ActivateDeActivateProcessingLocation(
      rec.Id,
      !rec.Is_Processing_Location,
    )
      .then(({ data }) => {
        if (data.IsSuccess) {
          const message = rec.Is_Processing_Location
            ? "Processing Location Deactivated Successfully"
            : "Processing Location Activated Successfully";
          toast.success(message);
          fetchOrganizationMasterList();
        } else {
          toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  const fetchOrganizationNamesList = () => {
    OrganizationMasterService.OrganizationNamesList()
      .then(({ data }) => {
        if (data.IsSuccess) {
          setOrgNames(data.Data);
        } else {
          toast.error("Failed to fetch organization names");
        }
      })
      .catch(() => toast.error("Something went wrong"));
  };

  const handleShowModal = () => {
    fetchOrganizationNamesList();
    setShowModal(true);
  };

  const toggleProcessingSort = () => {
    setProcessingSortOrder((prev) => (prev === "desc" ? "asc" : "desc"));
  };

  return (
    <>
      <CommonContainer
        heading="Organization Location Mapping Master"
        buttonText="Add Mapping"
        onButtonClick={handleShowModal}
      >
        {/* <div className="d-flex flex-column flex-lg-row align-items-center justify-content-between"> */}
        {/* <div
            className="search-box patient-visit-search-box"
            style={{ position: "relative", width: "320px" }}
          >
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search by Org Location Name & Org Name"
                value={searchData}
                onChange={(e) => setSearchData(e.target.value)}
                style={{
                  paddingRight: "35px",
                  borderRadius: "5px",
                  border: "1px solid #ddd",
                }}
              />
              <button
                className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-box-search-btn"
                style={{
                  padding: "5px",
                  position: "absolute",
                  top: "0",
                  right: "0px",
                  height: "35px",
                  width: "45px",
                  borderTopLeftRadius: "0",
                  borderBottomLeftRadius: "0",
                }}
                disabled={searchLoading}
              >
                <FaSearch />
              </button>
            </div>
          </div> */}

          
        <div
          className="column-search-wrapper"
        >
          <div>
            <select
              className="form-select column-search-dropdown"
              // style={{ width: "170px" }}
              value={selectedSearchColumn}
              onChange={(e) => setSelectedSearchColumn(e.target.value)}
            >
              {searchColumns.map((col) => (
                <option key={col.value} value={col.value}>
                  {col.label}
                </option>
              ))}
            </select>
          </div>

          {/* Search Input */}
          <div className="" style={{ position: "relative" }}>
            <input
              type="text"
              className="form-control org-loc-search"
              placeholder={`Search ${
                searchColumns.find((c) => c.value === selectedSearchColumn)
                  ?.label
              }`}
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
              style={{
                paddingRight: "35px",
                borderRadius: "5px",
                border: "1px solid #ddd",
                // width: "320px",
              }}
            />

            <button
              className="btn custom-sumbitbtn d-flex align-items-center justify-content-center patient-visit-search-box-search-btn"
              style={{
                padding: "5px",
                position: "absolute",
                top: "0",
                right: "0px",
                height: "35px",
                width: "45px",
                borderTopLeftRadius: "0",
                borderBottomLeftRadius: "0",
              }}
              disabled={searchLoading}
            >
              <FaSearch />
            </button>
          </div>
        </div>
        {/* </div> */}

        <div>
          <div className="table-responsive">
            <table className="table table-bordered custom-table">
              <thead>
                <tr>
                  <th style={{ width: "5%" }}>Org ID</th>
                  <th style={{ width: "30%" }}>Org Name</th>
                  <th style={{ width: "13%" }}>Org Location ID</th>
                  <th style={{ width: "25%" }}>Org Location Name</th>
                  <th style={{ width: "10%" }}>Is Active</th>
                  <th style={{ width: "18%" }}>
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <span>Is Processing Location</span>

                      <span
                        style={{ cursor: "pointer" }}
                        onClick={toggleProcessingSort}
                        title={
                          processingSortOrder === "asc"
                            ? "Sort by Active"
                            : "Sort by Inactive"
                        }
                      >
                        {processingSortOrder === "asc" ? (
                          <FaArrowDown size={13} />
                        ) : (
                          <FaArrowUp size={13} />
                        )}
                      </span>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody
                style={{ fontSize: "0.5rem" }}
                className="patient-list-small-font"
              >
                {searchLoading ? (
                  <tr>
                    <td colSpan="11" className="text-center py-3">
                      <div className="flex justify-center items-center gap-2 primary-green">
                        <FaSpinner
                          size={16}
                          color="green"
                          className="fa-spin"
                        />
                      </div>
                    </td>
                  </tr>
                ) : currentOrganizationMasterList?.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No Mappings Found
                    </td>
                  </tr>
                ) : (
                  currentOrganizationMasterList.map((rec) => (
                    <tr className="patient-list-row" key={rec.Id}>
                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.OrganizationId || "-"}
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.OrganizationName || "-"}
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.OrgLocationId || "-"}
                      </td>

                      <td
                        style={{ textAlign: "center", verticalAlign: "middle" }}
                      >
                        {rec?.OrgLocationName || "-"}
                      </td>

                      <td>
                        {rec?.IsActive ? (
                          <FaToggleOn
                            title="Deactivate Mapping"
                            color="green"
                            size={16}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setConfirmationDescription(
                                rec.IsActive
                                  ? "Are you sure you want to deactivate this mapping?"
                                  : "Are you sure you want to activate this mapping?",
                              );

                              setConfirmAction(
                                () => () =>
                                  handleActivateDeActivateOrgLocationMapping(
                                    rec,
                                  ),
                              );
                              setShowConfirmationModal(true);
                            }}
                          />
                        ) : (
                          <FaToggleOff
                            title="Activate Mapping"
                            color="red"
                            size={16}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setConfirmationDescription(
                                rec.IsActive
                                  ? "Are you sure you want to deactivate this mapping?"
                                  : "Are you sure you want to activate this mapping?",
                              );

                              setConfirmAction(
                                () => () =>
                                  handleActivateDeActivateOrgLocationMapping(
                                    rec,
                                  ),
                              );
                              setShowConfirmationModal(true);
                            }}
                          />
                        )}
                      </td>
                      <td>
                        {rec?.Is_Processing_Location ? (
                          <FaToggleOn
                            title="Deactivate Processing Location"
                            color="green"
                            size={16}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setConfirmationDescription(
                                rec.Is_Processing_Location
                                  ? "Are you sure you want to deactivate processing location?"
                                  : "Are you sure you want to activate processing location?",
                              );

                              setConfirmAction(
                                () => () =>
                                  handleActivateDeActivateProcessingLocation(
                                    rec,
                                  ),
                              );

                              setShowConfirmationModal(true);
                            }}
                          />
                        ) : (
                          <FaToggleOff
                            title="Activate Processing Location"
                            color="red"
                            size={16}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setConfirmationDescription(
                                rec.Is_Processing_Location
                                  ? "Are you sure you want to deactivate processing location?"
                                  : "Are you sure you want to activate processing location?",
                              );

                              setConfirmAction(
                                () => () =>
                                  handleActivateDeActivateProcessingLocation(
                                    rec,
                                  ),
                              );

                              setShowConfirmationModal(true);
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {filteredOrganizationMasterList.length > itemsPerPage && (
            <CommonPagination
              pageList={filteredOrganizationMasterList}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </div>
      </CommonContainer>

      {showConfirmationModal && (
        <CommonConfirmationModal
          setShowConfirmationModal={setShowConfirmationModal}
          modalLoader={modalLoader}
          description={confirmationDescription}
          onConfirm={() => {
            setModalLoader(true);
            confirmAction?.();
            setShowConfirmationModal(false);
            setModalLoader(false);
          }}
        />
      )}

      {showModal && (
        <OrgLocationMappingModal
          showModal={showModal}
          fetchOrganizationMasterList={fetchOrganizationMasterList}
          orgNames={orgNames}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
};

export default OrgLocMappingMasterComponent;
